import Login from '../../../components/Public/Login';
import PasswordReset from '../../../components/Public/PasswordReset';
import AcceptInvitation from '../../../components/Public/AcceptInvitation';

export const PUBLIC_ROUTES = {
  login: {
    path: '/login',
    exact: true,
    additional: {
      component: Login,
      protected: false,
    },
  },
  passwordReset: {
    path: '/password/reset',
    exact: true,
    additional: {
      component: PasswordReset,
      protected: false,
    },
  },
  acceptInvitation: {
    path: '/invite/:token',
    exact: true,
    additional: {
      component: AcceptInvitation,
      protected: false,
    },
  },
}


